var _circle, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPoints(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 34,
    viewBox: "0 0 34 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 17,
    cy: 17,
    r: 16.5,
    stroke: "#44AFAF"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_24_197)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.12207 21.7552L13.064 14.7134L21.8388 23.5701L24.9936 10.2427",
    stroke: "#44AFAF",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.21948 23.8365C10.3619 23.8365 11.2881 22.9183 11.2881 21.7857C11.2881 20.6531 10.3619 19.7349 9.21948 19.7349C8.07702 19.7349 7.15088 20.6531 7.15088 21.7857C7.15088 22.9183 8.07702 23.8365 9.21948 23.8365Z",
    fill: "white",
    stroke: "#44AFAF",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.6682 24.8404C22.8107 24.8404 23.7368 23.9223 23.7368 22.7896C23.7368 21.657 22.8107 20.7388 21.6682 20.7388C20.5258 20.7388 19.5996 21.657 19.5996 22.7896C19.5996 23.9223 20.5258 24.8404 21.6682 24.8404Z",
    fill: "white",
    stroke: "#44AFAF",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.7864 13.2613C25.9288 13.2613 26.855 12.3432 26.855 11.2105C26.855 10.0779 25.9288 9.15967 24.7864 9.15967C23.6439 9.15967 22.7178 10.0779 22.7178 11.2105C22.7178 12.3432 23.6439 13.2613 24.7864 13.2613Z",
    fill: "white",
    stroke: "#44AFAF",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.0706 16.6612C14.213 16.6612 15.1392 15.7431 15.1392 14.6104C15.1392 13.4778 14.213 12.5596 13.0706 12.5596C11.9281 12.5596 11.002 13.4778 11.002 14.6104C11.002 15.7431 11.9281 16.6612 13.0706 16.6612Z",
    fill: "white",
    stroke: "#44AFAF",
    strokeMiterlimit: 10
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_24_197"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 22,
    height: 18,
    fill: "white",
    transform: "translate(6 8)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPoints);
export default __webpack_public_path__ + "static/media/points.fedb4d1daf9b15f1979ade872a6c6e31.svg";
export { ForwardRef as ReactComponent };